//board.js
//JavaScript for board pages
console.log('board.js');

import _ from 'lodash';

import axios from 'axios';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import { alphaSectionsMake } from './alphaSectionsMake';
import { sortArrayByKey } from './sortArrayByKey';

//HTML attribute escaper
import { escape, unescape } from 'html-escaper';

//Vue
import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';
import ToastService from 'primevue/toastservice';
import Paginator from 'primevue/paginator';
import tooltipDirective from './directives/tooltip.js';

import SoundUploader from './components/SoundUploader.vue';
import ImageUploader from './components/ImageUploader.vue';
import SoundPlayer from './components/SoundPlayer.vue';
import AudioEditor from './components/AudioEditor.vue';
import TranscriptSuggestion from './components/TranscriptSuggestion.vue';
import TagVoter from './components/TagVoter.vue';
import Search from './components/Search.vue';
import Crosspromotion from './components/Crosspromotion.vue';
import AudioRecorder from './components/AudioRecorder.vue';
import WebSocketsIndicator from './components/WebSocketsIndicator.vue';
import SoundDownloader from './components/SoundDownloader.vue';
import NotificationPreference from './components/NotificationPreference.vue';
import FavoriteBoard from './components/FavoriteBoard.vue';
import TtsExpressionTags from './components/TtsExpressionTags.vue';
import MyTTSPhrases from './components/MyTTSPhrases.vue';
import TtsRequestModal from './components/TtsRequestModal.vue';

const PrimeVuePreset = definePreset(Lara, {
    semantic: {
        primary: {
            50: '{orange-50}',
            100: '{orange-100}',
            200: '{orange-200}',
            300: '{orange-300}',
            400: '{orange-400}',
            500: '{orange-500}',
            600: '{orange-600}',
            700: '{orange-700}',
            800: '{orange-800}',
            900: '{orange-900}',
            950: '{orange-950}',
        }
    }
});

//Cookies
import Cookies from 'js-cookie'

import { auto } from '@popperjs/core';

//Profanity filter
import { profanity } from '@2toad/profanity';

//Format time into human-readable format
import { isLength } from 'lodash';

//Alerts library
import Swal from 'sweetalert2';

//Lazy loading component
import LazyComponent from 'v-lazy-component';

import pluralize from 'pluralize';

//Websockets
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
if (!window.Pusher) {
    window.Pusher = Pusher;
}
if (!window.Echo) {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: 'soundbites',
        wsHost: window.location.hostname,
        // wsPort: 6001,
        cluster: 'pusher1',
        forceTLS: false,
        disableStats: true,
    });

    //Connected to websockets success message
    window.Echo.connector.pusher.connection.bind('connected', () => {
        console.log('WebSocket connection established');
    });

    //Error if cannot connect to websockets
    window.Echo.connector.pusher.connection.bind('unavailable', function () {
        console.error('Pusher/Websockets unavailable');
    });

    //Disconnect from Echo on page unload
    window.addEventListener('pagehide', function () {
        if (window.Echo) {
            console.log('Disconnecting from Echo');
            window.Echo.disconnect();
        }
    });
}
//End of Websockets

//Check if page was already loaded
if (window.performance && window.performance.navigation.type === 2) {
    console.log('Page was already loaded (method 2)');
    window.pageshow_persisted = true;
}

//Global variable from view containing the board ID
var board_id = window.board_id;

window.vueApp = createApp({
    data: function () {
        return {
            board: [], //Board data to show
            board_data_lastRetrieved: null, //Timestamp of when board data was last retrieved
            soundsDisplayLimit: 750, //Default limit
            perPage: 750,
            dataLoadingInProgress: false, //For loading indicator
            editEnabled: false, //User is allowed to edit this board. Has methods for setting, unsetting and toggling
            editMetaEnabled: false, //User has chosen to edit meta details. Set directly
            boardEditSubmitting: false, //Edit form is currently submitting
            editSoundsEnabled: false, //User has chosen to edit sounds. Set directly
            soundsEdited: false, //Sounds have been edited by user during this session
            soundUploadQueueCount: 0,
            soundUploadProgress: 0,
            soundUploadCompletedCount: 0, // Number of completed uploads
            soundUploadTotalCount: 0, // Total number of files to upload
            maxConcurrentUploads: 5, // Maximum number of concurrent uploads
            uploadQueue: [], // Files waiting to upload
            activeUploads: 0, // Number of currently active uploads
            searchData: { //Search result data
                boards: [],
                sounds: []
            },
            searchText: '',
            currentRequests: [], //XHR requests to enable aborting,
            showWaveforms: false, //To aid in controlling loading order of waveforms, after sounds have been requested
            showDownloads: false,
            sound_requestedToDownload: false, //Store the last requested sound to download, to aid in CAPTCHA presentation
            selectedSound: false, //Currently selected sound, used to populate options modal
            keysOrderArray: '1234567890-=qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM<>!@#$%^&*()~`\|"\'?/,.'.split(''),
            volume: 100,
            hCaptchaLoaded: false, //We are dynamically loading HCaptcha scripts, as they are rarely used
            boardStale: false,
            listView: false,
            controlsVisible: true,
            ttsPhraseText: null, //TTS phrase to queue for rendering
            ttsLanguage: null, //Selected language for multilingual TTS (null = auto-detect)
            ttsLangDropdownOpen: false,
            ttsLanguageOptions: [
                { value: null,  label: 'Auto',                flag: null },
                { value: 'ar',  label: 'Arabic',             flag: 'sa' },
                { value: 'da',  label: 'Danish',            flag: 'dk' },
                { value: 'de',  label: 'German',            flag: 'de' },
                { value: 'el',  label: 'Greek',             flag: 'gr' },
                { value: 'en',  label: 'English',           flag: 'gb' },
                { value: 'es',  label: 'Spanish',           flag: 'es' },
                { value: 'fi',  label: 'Finnish',           flag: 'fi' },
                { value: 'fr',  label: 'French',            flag: 'fr' },
                { value: 'he',  label: 'Hebrew',            flag: 'il' },
                { value: 'hi',  label: 'Hindi',             flag: 'in' },
                { value: 'it',  label: 'Italian',           flag: 'it' },
                { value: 'ja',  label: 'Japanese',          flag: 'jp' },
                { value: 'ko',  label: 'Korean',            flag: 'kr' },
                { value: 'ms',  label: 'Malay',             flag: 'my' },
                { value: 'nl',  label: 'Dutch',             flag: 'nl' },
                { value: 'no',  label: 'Norwegian',         flag: 'no' },
                { value: 'pl',  label: 'Polish',            flag: 'pl' },
                { value: 'pt',  label: 'Portuguese',        flag: 'pt' },
                { value: 'ru',  label: 'Russian',           flag: 'ru' },
                { value: 'sv',  label: 'Swedish',           flag: 'se' },
                { value: 'sw',  label: 'Swahili',           flag: 'ke' },
                { value: 'tr',  label: 'Turkish',           flag: 'tr' },
                { value: 'zh',  label: 'Chinese',           flag: 'cn' },
            ],
            ttsCallPending: false, //For feedback after making TTS request
            ttsProblem: null, //Is there a current problem with TTS engine
            showDropTarget: false,
            contextMenuEnableDownload: false,
            contextMenuEnableMoreOptions: false,
            isMobile: false, //Is this a mobile browser
            isLowBandwidth: null, //Is the connection low bandwidth. Not all browsers can be detected, so defaults to null
            preloadSoundsLimit: null, //Limit number of sounds to preload
            sort: null,
            refreshEnabled: true, //Should the refresh button be enabled
            filterText: null, //Text to filter sounds by (separate from search)
            minigameFocusInterval: null, //Interval for minigame iframe focus
            gptRequested: false, // kept for any legacy references; superseded by aiEnhancing
            aiEnhancing: false,
            aiEnhanced: false,
            aiEnhanceOriginalText: null,
            isProfanity: false, //Is the user using profanity
            ignoreBoardDeleted: false, //Ignore live updates of board being deleted
            favorites: [], //User or session's favorite sounds (array of IDs)
            error: false,
            success: false,
        }
    },
    methods: {
        //Load board data from API
        //To prevent registering a hit to this board (for example when uploading a sound and reloading data)
        //board_data_inline = false, register_hit = false
        load: function (board_data_inline, register_hit = true, show_loading_indicator = true, reference = null, load_all = false) {
            console.log('load');

            // // Don't reload data for TTS boards
            // if (this.board.board_is_tts && this.board.sounds.length > 0 && !board_data_inline) {
            //     console.log('Board is TTS and already has sounds, skipping reload to prevent disrupting TTS queue');
            //     return;
            // }

            if (show_loading_indicator) {
                this.dataLoadingInProgress = true;
            }

            //Use preloaded data from the view, to avoid extra roundtrip loading from API
            if (typeof board_data_inline !== 'undefined' && board_data_inline) {
                console.log('Using preload data');

                if (!new URLSearchParams(window.location.search).has('all_sounds')) { //Temporary for bot defeater
                    //If the page was already loaded via back button, use cached data first, then refresh in background
                    if (window.pageshow_persisted) {
                        console.log('Page was already loaded (pageshow persisted), using cached data and refreshing in background');
                        // Use the cached inline data immediately to prevent flash
                        this.board = board_data_inline;
                        // Refresh data in background after a short delay
                        setTimeout(() => {
                            this.load(null, false, false, 'board_data_inline_refresh');
                        }, 100);
                        // Continue with normal setup using cached data
                    } else {
                        console.log('Page was not already loaded (pageshow not persisted), continuing to use inline data.');
                    }
                }

                //Reload data silently after 5 seconds. The page may have been cached and this will refresh it
                //This is not done on show mode, as show boards are infrequently updated and refresh button would still work
                // if (! new URLSearchParams(window.location.search).has('all_sounds')) { //Temporary for bot defeater
                // setTimeout(() => {
                //         this.load(null, false, false, 'board_data_inline_refresh');
                //     }, 5000);
                // }

                //Update retrieval timestamp
                this.board_data_lastRetrieved = Date.now();

                this.board = board_data_inline;

                //Show waveforms after sound loading requests have been made, if waveforms should be shown
                //Individually tracking each one would be fraught with unreliability and counterproductive
                setTimeout(() => {
                    this.showWaveforms = this.shouldShowWaveforms;
                }, 3500);

                this.dataLoadingInProgress = false;

                //Set default sort if not already set
                if (!this.sort) {
                    console.log('Set default sort');
                    switch (this.board.board_recommend_sort) {
                        case 'alpha':
                            this.sort = 'sound_order';
                            break;

                        case 'created-':
                        default:
                            this.sort = '-id';
                            break;
                    }
                    console.log('Sort by ' + this.sort);
                }

                //Log to hits table via Node, unless register_hit = false
                if (register_hit) {
                    axios.post('/api/v1/hits/boards/' + this.board.id)
                        .then(function (response) {
                            console.log(response);
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }

                // //Set GPT enabled option to default
                // if (this.board.tts_engine) {
                //     this.gptRequested = Boolean(this.board.tts_engine.gpt_enabled);
                // }

                //If this is a TTS board, remove the 'Source' sound, and alter sound count accordingly
                if (this.board.board_is_tts) {
                    const source_sound_found = _.find(this.board.sounds, function (sound) {
                        return sound.sound_transcript === 'Source';
                    });
                    if (source_sound_found) {
                        this.board.sounds = _.filter(this.board.sounds, function (sound) {
                            return sound.sound_transcript !== 'Source';
                        })

                        this.board.sounds_count = this.board.sounds_count - 1;
                    }
                }

                return;
            }

            console.log('load from API');
            let api_url = new URL('/api/v1/boards/' + board_id, window.location.href);
            api_url.searchParams.append('ref', reference);

            //Only load a limited number of sounds if there is a displayLimit set, otherwise load all sounds
            if (!load_all && this.soundsDisplayLimit) {
                api_url.searchParams.append('limit', this.soundsDisplayLimit);
            }

            //Sorting
            if (this.sort) {
                api_url.searchParams.append('sort', this.sort);
            }

            //Filtering
            if (this.filterText) {
                api_url.searchParams.append('filter[sound_transcript]', this.filterText.trim());
            }

            axios.get(api_url.href)
                .then((response) => {
                    //Update retrieval timestamp
                    this.board_data_lastRetrieved = Date.now();

                    console.log(response.data);

                    this.board = response.data.data;

                    //If this is a TTS board, remove the 'Source' sound, and alter sound count accordingly
                    if (this.board.board_is_tts) {
                        const source_sound_found = _.find(this.board.sounds, function (sound) {
                            return sound.sound_transcript === 'Source';
                        });
                        if (source_sound_found) {
                            this.board.sounds = _.filter(this.board.sounds, function (sound) {
                                return sound.sound_transcript !== 'Source';
                            })

                            this.board.sounds_count = this.board.sounds_count - 1;
                        }
                    }

                    console.log('Success', this.board);
                    // this.load_waveforms();

                    this.dataLoadingInProgress = false;
                    this.boardStale = false;

                    //Show waveforms after sound loading requests have been made, if waveforms should be shown
                    //Individually tracking each one would be fraught with unreliability and counterproductive
                    setTimeout(() => {
                        this.showWaveforms = this.shouldShowWaveforms;
                    }, 5000);

                    //Log to hits table via Node, unless register_hit = false
                    if (register_hit) {
                        axios.post('/api/v1/hits/boards/' + this.board.id)
                            .then(function (response) {
                                console.log(response);
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                })
                .catch((error) => {
                    // this.showErrorMessage("An error occurred");
                    window.$toast.add({
                        severity: 'error',
                        summary: 'Error loading board',
                        detail: 'There was a problem loading the board data. Please try again.',
                        life: 10000
                    });
                    this.dataLoadingInProgress = false;
                });
        },
        refresh: function () {
            console.log('refresh');

            //Disable refresh button for 5 seconds
            this.refreshEnabled = false;
            setTimeout(() => {
                this.refreshEnabled = true;
            }, 5000);

            //Load data
            this.load(null, false, true, 'refresh');

            //Analytics
            if (typeof gtag !== 'undefined') {
                gtag('event', 'refresh', {
                    'event_category': 'refresh',
                    'event_label': 'refresh',
                });
            };
        },
        // load_waveforms: function() {
        //     console.log('load waveforms after delay');
        //     _.delay( () => {
        //         this.showWaveforms = true;
        //         console.log('load waveforms now');
        //     }, 500);
        // },
        //Throttled text/transcript update
        update_sound_throttled: _.debounce(
            function (sound_id) {
                this.update_sound(sound_id);
            },
            1000),
        //Update sound text/transcript with API
        update_sound: function (sound_id) {
            this.soundsEdited = true;
            console.log('update_sound', sound_id);
            var sounds_matched = this.board.sounds.filter(function (sound) {
                return sound.id === sound_id;
            });
            console.log('sounds_matched', sounds_matched);
            axios.put('/api/v1/sounds/' + sound_id, { sound_transcript: sounds_matched[0].sound_transcript })
                .then((response) => {
                })
                .catch((error) => {
                    this.showErrorMessage("An error occurred");
                });
        },
        //Store image blob to API, then reload the page
        store_boardImage: function (blob) {
            console.log('store_boardImage', blob);
            var myFormData = new FormData();
            myFormData.append('imgUpload', blob);
            myFormData.append('_method', 'PUT'); //Laravel hates PUT from JQuery!
            //Upload to API
            axios.post('/api/v1/boards/' + this.board.id, myFormData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(function (response) {
                    console.log(response.data);
                    //Reload page
                    window.location.reload(true);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        //Queue storing sound
        store_sound: function ({ file, autoLabel }) {
            this.soundUploadQueueCount += 1;
            this.soundUploadTotalCount += 1;

            // Get or create modal instance
            if (!this.uploadProgressModalInstance) {
                const modalElement = document.getElementById('uploadProgressModal');
                this.uploadProgressModalInstance = new bootstrap.Modal(modalElement, {
                    backdrop: false,
                    keyboard: true
                });
            }
            this.uploadProgressModalInstance.show();

            // Add file to upload queue
            this.uploadQueue.push({ file, autoLabel });

            // Calculate overall progress
            this.soundUploadProgress = (this.soundUploadCompletedCount / this.soundUploadTotalCount) * 100;

            // Process the queue
            this.processUploadQueue();
        },
        //Process the upload queue with concurrency control
        processUploadQueue: function () {
            // Start uploads up to the max concurrent limit
            while (this.activeUploads < this.maxConcurrentUploads && this.uploadQueue.length > 0) {
                const item = this.uploadQueue.shift();
                // Don't await - let it run concurrently
                this.performUpload(item).catch(err => {
                    console.error('Upload failed:', err);
                });
            }
        },
        //Perform the actual upload
        performUpload: async function ({ file, autoLabel }) {
            this.activeUploads++;

            const formData = new FormData();
            formData.append('board_id', this.board.id);
            formData.append('upload[]', file);

            try {
                const response = await axios.post('/api/v1/sounds/store', formData);

                console.log('store_sound success', response.data);

                // Increment completed count
                this.soundUploadCompletedCount++;

                // Update overall progress
                this.soundUploadProgress = (this.soundUploadCompletedCount / this.soundUploadTotalCount) * 100;

                // Ensure sound is displayed by increasing limit
                this.soundsDisplayLimit = this.soundsDisplayLimit + 1;

                // Set sort to latest
                this.sort = '-id';

                window.$toast.add({
                    severity: 'success',
                    summary: 'Sound added',
                    detail: response.data.message || 'Sound added successfully',
                    life: 2000,
                });

                // Queue transcription for each uploaded sound if auto label is enabled
                if (autoLabel && response.data.data && response.data.data.sounds) {
                    response.data.data.sounds.forEach(sound => {
                        axios.post(`/api/v1/sounds/${sound.id}/queue_transcription`, {
                            language: navigator.language || navigator.userLanguage,
                        }).catch(err => {
                            console.error('Failed to queue transcription for sound', sound.id, err);
                        });
                    });
                }

            } catch (error) {
                console.error('Upload error:', error);

                // Display error message
                Swal.fire({
                    title: 'Error',
                    text: error.response?.data?.message || 'An error occurred during upload',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    theme: 'auto'
                });
            } finally {
                this.activeUploads--;
                this.soundUploadQueueCount -= 1;

                // Check if this was the last upload BEFORE processing more
                const isLastUpload = this.soundUploadQueueCount === 0 && this.activeUploads === 0 && this.uploadQueue.length === 0;

                // Process next items in queue
                if (!isLastUpload && this.uploadQueue.length > 0) {
                    this.processUploadQueue();
                }

                // If all done, hide modal and reload board
                if (isLastUpload) {
                    if (this.uploadProgressModalInstance) {
                        this.uploadProgressModalInstance.hide();
                    }
                    // Reset counters
                    this.soundUploadCompletedCount = 0;
                    this.soundUploadTotalCount = 0;
                    this.soundUploadProgress = 0;
                    this.load(null, false, true, 'store_sound');
                }
            }
        },

        //Delete sound with confirmation
        destroy_sound: function (sound_id) {
            console.log("destroy_sound");

            // Check if user has opted to skip confirmation
            const skipConfirmation = localStorage.getItem('skip_sound_delete_confirmation') === 'true';

            if (skipConfirmation) {
                this.performSoundDeletion(sound_id);
                //Close modal
                const soundModal = bootstrap.Modal.getInstance(document.getElementById('soundModal'));
                if (soundModal) soundModal.hide();
                return;
            }

            Swal.fire({
                title: 'Delete Sound?',
                text: 'Are you sure you want to delete this sound?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Delete',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#dc3545',
                cancelButtonColor: '#6c757d',
                input: 'checkbox',
                inputPlaceholder: "Don't ask me again",
                theme: 'auto'
            }).then((result) => {
                if (result.isConfirmed) {
                    // Save preference if checkbox was checked
                    if (result.value) {
                        localStorage.setItem('skip_sound_delete_confirmation', 'true');
                    }

                    this.performSoundDeletion(sound_id).then(() => {
                    }).catch(() => {
                        //Error handled in performSoundDeletion
                    }).then(() => {
                        this.dataLoadingInProgress = false;
                        //Close modal
                        const soundModal = bootstrap.Modal.getInstance(document.getElementById('soundModal'));
                        if (soundModal) soundModal.hide();
                    });
                }
            });
        },
        //Perform sound deletion
        performSoundDeletion: function (sound_id) {
            return new Promise((resolve, reject) => {
                const index = _.findIndex(this.board.sounds, { 'id': sound_id });

                //Show progress indicator
                this.dataLoadingInProgress = true;

                axios.delete(`/api/v1/sounds/${sound_id}`)
                    .then((response) => {
                        this.board.sounds.splice(index, 1);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        // this.showErrorMessage("An error occurred");
                        this.showErrorMessage(error.response?.data?.message || 'An error occurred while deleting the sound');
                        reject(error);
                    })
                    .finally(() => {
                        this.dataLoadingInProgress = false;
                    });
            });
        },
        show_soundModal: function (sound) {
            //Share individual sound with a popup modal containing dynamic AddToAny
            console.log('show_soundModal handled');
            console.log(sound);

            //Set data to populate modal with
            this.selectedSound = sound;

            let getUrl = window.location;
            let baseUrl = getUrl.protocol + "//" + getUrl.host;
            let sound_link = baseUrl + sound.link;
            console.log('sound link: ' + sound_link);

            //If HTML5 Web Share API is available and this is a mobile browser
            if (navigator.share) {
                console.log('HTML5 Web Share API available and this is a mobile browser');
                var a2a_content = `<button class="btn btn-large btn-warning shareBtn" id="soundShareBtn">
                    <i class="fas fa-fw fa-share-alt" aria-hidden="true"></i><br />Share</button>`;
                const shareButtonsContainer = document.querySelector("#soundModal .modal-body .share-buttons");
                if (shareButtonsContainer) {
                    shareButtonsContainer.innerHTML = a2a_content;
                }
                const soundShareBtn = document.getElementById('soundShareBtn');
                if (soundShareBtn) {
                    soundShareBtn.addEventListener('click', () => {
                        console.log('soundShareBtn pressed');
                        //If Web Share API is available, and is mobile browser
                        if (navigator.share) {
                            navigator.share({
                                title: sound.sound_transcript,
                                url: sound_link
                            }).then(() => {
                                console.log('Shared via HTML5 Web Share API');
                            })
                                .catch(console.error);
                        } else {
                            //Otherwise classic share by opening modal
                            const shareBoardModal = new bootstrap.Modal(document.getElementById('shareBoardModal'));
                            shareBoardModal.show();
                        }
                    });
                }
            } else {
                //Otherwise use Add2Any
                //Set the content of the modal to contain share buttons with a dynamic link
                var a2a_content = `
                <div class="a2a_kit a2a_kit_size_32 a2a_default_style" data-a2a-url="` + escape(sound_link) + `" data-a2a-title="` + escape(sound.sound_transcript) + `">
                <a class="a2a_button_facebook"></a>
                <a class="a2a_button_twitter"></a>
                <a class="a2a_button_email"></a>
                <a class="a2a_button_google_gmail"></a>
                <a class="a2a_button_reddit"></a>
                <a class="a2a_button_whatsapp"></a>
                <a class="a2a_button_pinterest"></a>
                <a class="a2a_button_telegram"></a>
                <a class="a2a_button_skype"></a>
                <a class="a2a_button_copy_link"></a>
                <a class="a2a_dd" href="https://www.addtoany.com/share"></a>
                </div>`
                const shareButtons = document.querySelector("#soundModal .modal-body .share-buttons");
                if (shareButtons) {
                    shareButtons.innerHTML = a2a_content;
                }
            }

            //Set link destination for 'Go to sound' button
            const goToSoundBtn = document.querySelector("#soundModal #share-go-to-sound");
            if (goToSoundBtn) {
                goToSoundBtn.setAttribute('href', sound_link);
            }

            //Set link destination for 'Go to board' button
            const goToBoardBtn = document.querySelector("#soundModal #share-go-to-board");
            if (goToBoardBtn) {
                goToBoardBtn.setAttribute('href', '/boards/' + sound.board_id);
            }

            //Set value of URL field ready for copy and pasting
            const shareLink = document.querySelector("#soundModal #share-link");
            if (shareLink) {
                shareLink.value = sound_link;
            }

            //Click to copy behaviors
            const copyLinkElements = document.querySelectorAll("#soundModal #share-copy-link, #soundModal #share-link");
            copyLinkElements.forEach(el => {
                el.addEventListener('click', function () {
                    //Get the text field
                    var copyText = document.getElementById("share-link");
                    //Select the text field
                    copyText.select();
                    copyText.setSelectionRange(0, 99999); //For mobile devices
                    //Copy the text inside the text field
                    document.execCommand("copy");
                    //Indicate copy success
                    const shareCopyLink = document.querySelector("#soundModal #share-copy-link");
                    if (shareCopyLink) {
                        shareCopyLink.innerHTML = '<i class="fas fa-fw fa-check"></i><br>Copy Link<br>';
                    }

                //Toast
                window.$toast.add({
                    severity: 'success',
                    summary: 'Link copied',
                    detail: 'The link has been copied to your clipboard.',
                    life: 2000,
                });
                });
            });

            //Reset copy indicator
            const resetCopyLink = document.querySelector("#soundModal #share-copy-link");
            if (resetCopyLink) {
                resetCopyLink.innerHTML = '<i class="fas fa-fw fa-copy"></i><br />Copy Link<br />';
            }

            //Show modal
            const soundModal = new bootstrap.Modal(document.getElementById('soundModal'));
            soundModal.show();

            //Close tooltips
            console.log('Close all tooltips');
            const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltips.forEach(el => {
                if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
                    const tooltip = bootstrap.Tooltip.getInstance(el);
                    if (tooltip) {
                        tooltip.hide();
                    }
                }
            });
        },
        webShare: function (sound) {
            if (navigator.share) {
                navigator.share({
                    title: 'Sound clip: \'' + sound.sound_transcript + '\'',
                    url: 'https://' + window.location.hostname + sound.link
                }).then(() => {
                    console.log('Shared.');
                })
                    .catch(console.error('Error sharing'));
            } else {
                console.log('Web Share API not available for sound ' + sound)
            }
        },
        //Show a context menu with options for sound
        show_contextMenu: function (sound, showContextMenuOptions = true) {
            console.log('show_contextMenu on board');
            console.log(sound);

            //Google analytics log
            if (typeof gtag === 'function') {
                gtag('event', 'context_menu_open', {
                    'event_category': 'Board',
                });
            }

            this.contextMenuEnableDownload = showContextMenuOptions;
            this.contextMenuEnableMoreOptions = showContextMenuOptions;
            this.contextMenuEnableDownload = true;

            //Set data to populate context menu with
            this.selectedSound = sound;

            const contextMenu = document.getElementById("context-menu");
            if (!contextMenu) return;

            //Get or cache context menu dimensions (prevents forced reflows on subsequent opens)
            if (!this.contextMenuDimensions) {
                //First time: measure dimensions off-screen to avoid flicker
                contextMenu.style.display = "block";
                contextMenu.style.position = "fixed";
                contextMenu.style.left = "-10000px";
                contextMenu.style.top = "-10000px";
                contextMenu.style.visibility = "hidden";
                
                //Read dimensions AFTER setting styles but BEFORE making visible
                this.contextMenuDimensions = {
                    width: contextMenu.offsetWidth,
                    height: contextMenu.offsetHeight
                };
                
                //Reset visibility
                contextMenu.style.visibility = "";
            }

            //Viewport dimensions (reading these doesn't cause reflow)
            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

            //Calculate position using cached dimensions
            const contextMenuWidth = this.contextMenuDimensions.width;
            const contextMenuHeight = this.contextMenuDimensions.height;

            //Default position for context menu will be cursor position
            var left = event.clientX;
            var top = event.clientY;

            //If click is too close to the right, open the menu without clipping the edge
            if ((event.clientX + contextMenuWidth + 25) > vw) {
                left = vw - (contextMenuWidth + 25);
            }

            //If click is too close to the bottom, open the menu without clipping the bottom
            if (event.clientY > vh - contextMenuHeight + 25) {
                top = event.clientY - contextMenuHeight;
            }

            console.log(left, top);

            //Batch all style writes together (prevents multiple reflows)
            contextMenu.style.display = "block";
            contextMenu.style.position = "fixed";
            contextMenu.style.left = left + "px";
            contextMenu.style.top = top + "px";
            contextMenu.classList.add("show");

            //Hide menu on option click
            const hideMenu = () => {
                const menu = document.getElementById("context-menu");
                if (menu) {
                    menu.classList.remove("show");
                    menu.style.display = "none";
                }
            };
            if (contextMenu) {
                contextMenu.querySelectorAll("a, button").forEach(el => el.addEventListener("click", hideMenu));
            }
            document.body.addEventListener("click", hideMenu);

        },
        openNewWindow: function (path) {
            console.log('openNewWindow');
            console.log(path);

            let getUrl = window.location;
            let baseUrl = getUrl.protocol + "//" + getUrl.host;
            let sound_link = baseUrl + path;
            console.log('sound link: ' + sound_link);

            window.open(sound_link);
        },
        copyToClipboard: function (path) {
            console.log('copyToClipboard');
            console.log(path);

            let getUrl = window.location;
            let baseUrl = getUrl.protocol + "//" + getUrl.host;
            let sound_link = baseUrl + path;
            console.log('sound link: ' + sound_link);

            var textArea = document.createElement("textarea");

            //Use 'invisible' textarea to copy

            // Place in the top-left corner of screen regardless of scroll position.
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;

            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textArea.style.width = '2em';
            textArea.style.height = '2em';

            // We don't need padding, reducing the size if it does flash render.
            textArea.style.padding = 0;

            // Clean up any borders.
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';

            // Avoid flash of the white box if rendered for any reason.
            textArea.style.background = 'transparent';

            textArea.value = sound_link;

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Copying text command was ' + msg);
            } catch (err) {
                console.log('Oops, unable to copy');
            }

            document.body.removeChild(textArea);

            //Toast
            window.$toast.add({
                severity: 'success',
                summary: 'Link copied',
                detail: 'The link has been copied to your clipboard.',
                life: 2000,
            });
        },
        tweet: function (path) {
            window.open('https://www.twitter.com/intent/tweet?url=' + encodeURIComponent('https://www.101soundboards.com' + path), '_blank');
        },
        // //Request reordering of a sound with the API (drag reordering)
        // reorder: function () {
        //     console.log("reorder");
        //     var self = this; //For browser compatibility. Use arrow functions if ES6/Babel
        //     reorder_array = [];
        //     reorder_csv = "";
        //     this.board.sounds.forEach(function (sound) {
        //         reorder_array.push(sound.id);
        //     });
        //     reorder_csv = reorder_array.join(",");
        //     axios.post('/api/v1/boards/' + self.board.id + '/reorder', { 'reorder_csv': reorder_csv })
        //     .then(function (response) {
        //         console.log('Reorder success', response.data);
        //     })
        //     .catch(function (error) {
        //         self.showErrorMessage("An error occurred");
        //     });
        // },
        getAlphaHeadingIfNewCharacter: function (previousSound, sound) {
            console.log('getAlphaHeadingIfNewCharacter', sound.sound_transcript);
            const alphabet = "abcdefghijklmnopqrstuvwxyz".split("");

            //If no previous, but current, return this as a heading
            if (typeof previousSound === 'undefined' && typeof sound !== 'undefined') {
                return sound.sound_transcript.substring(0, 1).toUpperCase();
            }
            //If previous and current
            if (typeof previousSound !== 'undefined' && typeof sound !== 'undefined') {
                //If character is not the same as the previous sound's character, and it is an alphabet character, emit a new heading
                if (sound.sound_transcript.substring(0, 1).toLowerCase() !== previousSound.sound_transcript.substring(0, 1).toLowerCase()) {
                    if (alphabet.includes(sound.sound_transcript.substring(0, 1).toLowerCase())) {
                        return sound.sound_transcript.substring(0, 1).toUpperCase();
                    }
                }
            }

            //If previous, and previous is a alphabet character, but current is not, return 'Other' heading
            if (typeof previousSound !== 'undefined' &&
                alphabet.includes(previousSound.sound_transcript.substring(0, 1).toLowerCase()) &&
                !alphabet.includes(sound.sound_transcript.substring(0, 1).toLowerCase())) {
                return 'Other';
            }

            //Edge case of a list only with entries starting with a symbol, will make a header starting with this symbol
            //This was considered fine and less cluttered than many symbol headers
            return false;
        },
        //Show debug data
        debugData: function () {
            console.log('debugData', this.board.sounds);
        },
        //Show error message
        showErrorMessage: function (message) {
            console.log('Show error message', message);
            Swal.fire({
                title: 'Error',
                text: message,
                icon: 'error',
                confirmButtonText: 'OK',
                timer: 5000,
                timerProgressBar: true,
                theme: 'auto'
            });
        },
        //Toggle edit mode
        toggleEdit: function () {
            console.log('toggleEdit');
            this.editEnabled = !this.editEnabled;
            console.log(this.editEnabled);
        },
        //Switch edit mode on
        enableEdit: function () {
            console.log('enableEdit');
            this.editEnabled = true;
            console.log(this.editEnabled);
        },
        //Switch edit mode off
        disableEdit: function () {
            console.log('disableEdit');
            this.editEnabled = false;
            console.log(this.editEnabled);
        },
        //Toggle showing download buttons for public user
        showDownloadsToggle: function () {
            this.showDownloads = !this.showDownloads;
        },
        //Toggle, or select, list view or board view. Also sets preference in a cookie
        listViewToggle: function (mode = null, save = true) {
            console.log('listViewToggle');
            switch (mode) {
                case 'list':
                    this.listView = true;
                    Cookies.set('listview', 'list', { expires: 7 })
                    break;

                case 'board':
                    this.listView = false;
                    Cookies.set('listview', 'board', { expires: 7 })
                    break;

                default:
                    this.listView = !this.listView;
            }

            console.log(this.listView);
        },
        controlsVisibleToggle: function () {
            this.controlsVisible = !this.controlsVisible;
            localStorage.setItem('controlsVisible', this.controlsVisible ? 'true' : 'false');
        },
        triggerDownloadSound: function (sound) {
            console.log('triggerDownloadSound (board)', sound);

            //Use SoundDownloader component to download sound
            if (this.$refs.soundDownloader) {
                this.$refs.soundDownloader.download(sound);
            } else {
                console.error('SoundPlayer: No soundDownloader ref');
            }
        },
        triggerEmbedSound: function (sound, event) {
            console.log('triggerEmbedSound (sound)');
            console.log(sound, event);
            const embed_string = '<iframe width="300" height="215" scrolling="no" frameborder="none" src="https://www.101soundboards.com' + sound.link + '/video/player_embed' + '" type="video/mp4"></iframe><br /><a href="' + 'https://www.101soundboards.com' + sound.link + '">' + sound.sound_transcript + '</a>';
            console.log(embed_string);

            var textArea = document.createElement("textarea");

            //Use 'invisible' textarea to copy

            // Place in the top-left corner of screen regardless of scroll position.
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;

            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textArea.style.width = '2em';
            textArea.style.height = '2em';

            // We don't need padding, reducing the size if it does flash render.
            textArea.style.padding = 0;

            // Clean up any borders.
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';

            // Avoid flash of the white box if rendered for any reason.
            textArea.style.background = 'transparent';

            textArea.value = embed_string;

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Copying text command was ' + msg);
                if (document.getElementById('embed_button')) {
                    document.getElementById('embed_button').innerHTML = 'Copied to Clipboard';
                }
            } catch (err) {
                console.log('Oops, unable to copy');
                if (document.getElementById('embed_button')) {
                    document.getElementById('embed_button').innerHTML = 'Unable to Copy To Clipboard';
                }
            }
            document.body.removeChild(textArea);
        },
        triggerPlaySound: function (sound) {
            console.log('playSound (board)');
            console.log(sound);
            //Call the play method on the individual sound
            console.log(this.$refs);
            this.$refs['soundPlayer_' + sound.id][0].play();
        },
        //Load a JavaScript file programatically and return a promise when loaded/error
        loadScript: function (script_url) {
            console.log('Load script ' + script_url)
            return new Promise((resolve, reject) => {
                let script_element = document.createElement('script');
                script_element.onload = function () {
                    console.log('Script ' + script_url + ' loaded')
                    resolve(true)
                };
                script_element.onerror = function (error) {
                    console.error('Script ' + script_url + ' loading error', error)
                    reject('Error loading script')
                }
                script_element.src = script_url;
                document.head.appendChild(script_element);
            })
        },
        //Show YouTube download modal
        ytDownloadModal: function () {
            console.log('ytDownloadModal');

            Swal.fire({
                title: 'Copy To Your Soundboard from a Link',
                html: `
                    <div class="text-left">
                        <p>You can paste a link to a video/sound from many external sites including Youtube, Vimeo, Twitch and SoundCloud, and we will download it and add it to your soundboard. This works for videos, music, podcasts and more.</p>
                        <p>You can also paste a <img src="/img/badge.svg" class="mx-1 align-bottom" width="20" height="20" alt="101 Soundboards logo" />101 Soundboards sound link to copy it to your board directly.</p>
                        <p>Now supporting playlists. Maximum length is <span class="badge badge-info text-white p-2">${import.meta.env.VITE_YTDOWNLOAD_PLAYLIST_MAX_LENGTH ?? 100}</span></p>
                        <p>Please note: Download speed and reliability may vary, as third-party services can sometimes make downloads slow or unreliable.</p>
                        <div class="mb-2 text-danger">
                            <i class="fa fa-fw fa-brands fa-youtube mr-2" title="YouTube"></i>
                            <i class="fa fa-fw fa-brands fa-soundcloud mr-2" title="SoundCloud"></i>
                            <i class="fa fa-fw fa-brands fa-twitch mr-2" title="Twitch"></i>
                            <i class="fa fa-fw fa-brands fa-instagram mr-2" title="Instagram"></i>
                            <i class="fa fa-fw fa-brands fa-facebook mr-2" title="Facebook"></i>
                            <i class="fa fa-fw fa-ellipsis-h ml-1" title="and more"></i>
                        </div>
                        <label for="swal-url-input" class="form-label">URL/Link:</label>
                        <input id="swal-url-input" class="swal2-input w-100" placeholder="YouTube/Twitch/Soundcloud/101 Soundboards Sound Link/Vimeo etc. URL" style="margin: 10px 0; width: 100%;">
                    </div>
                `,
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: 'Add to Your Soundboard',
                cancelButtonText: 'Cancel',
                denyButtonText: 'My Grabs Status',
                confirmButtonColor: '#007bff',
                cancelButtonColor: '#28a745',
                denyButtonColor: '#17a2b8',
                focusConfirm: false,
                theme: 'auto',
                preConfirm: () => {
                    const url = document.getElementById('swal-url-input').value;
                    if (!url) {
                        Swal.showValidationMessage('Please enter a URL');
                        return false;
                    }
                    return url;
                }
            }).then((result) => {
                if (result.isDenied) {
                    window.location.href = '/grabs';
                    return;
                }
                if (result.isConfirmed) {
                    const url = result.value;

                    //Check if this is a YouTube playlist URL
                    const isPlaylist = url.includes('playlist?list=') ||
                        url.includes('&list=') ||
                        (url.includes('youtube.com') && url.includes('list='));

                    if (isPlaylist) {
                        // Show playlist confirmation dialog
                        Swal.fire({
                            title: 'Playlist Detected',
                            html: `
                                <div class="text-left">
                                    <p><strong>You've pasted a YouTube playlist link.</strong></p>
                                    <p>This will attempt to download and add <strong>every video in the playlist</strong> to your soundboard. This could be many videos depending on the playlist size.</p>
                                    <p>Maximum playlist length is <span class="badge badge-info text-white p-2">${import.meta.env.VITE_YTDOWNLOAD_PLAYLIST_MAX_LENGTH ?? 100}</span> videos.</p>
                                    <p>Are you sure you want to download the entire playlist?</p>
                                </div>
                            `,
                            icon: 'question',
                            showCancelButton: true,
                            confirmButtonText: 'Yes, Download Playlist',
                            cancelButtonText: 'Cancel',
                            confirmButtonColor: '#dc3545',
                            cancelButtonColor: '#6c757d',
                            theme: 'auto'
                        }).then((playlistResult) => {
                            if (playlistResult.isConfirmed) {
                                this.submitYouTubeDownload(url);
                            }
                        });
                    } else {
                        // Not a playlist, proceed normally
                        this.submitYouTubeDownload(url);
                    }
                }
            });
        },
        //Submit YouTube download request to server
        submitYouTubeDownload: function (url) {
            console.log('Submitting URL:', url);

            //Create form data and submit
            const formData = new FormData();
            formData.append('url', url);
            formData.append('_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));

            //Show loading state
            Swal.fire({
                title: 'Processing...',
                text: 'Sending copy request...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                },
                theme: 'auto'
            });

            // ubmit to server
            axios.post(`/boards/${this.board.id}/yt_download`, formData)
                .then(response => {
                    Swal.fire({
                        title: 'Success!',
                        text: 'Your Grab task has been requested.',
                        icon: 'success',
                        confirmButtonText: 'OK',
                        showDenyButton: true,
                        denyButtonText: 'My Grabs Status',
                        denyButtonColor: '#17a2b8',
                        theme: 'auto'
                    }).then((result) => {
                        if (result.isDenied) {
                            window.location.href = '/grabs';
                            return;
                        }
                        //Reload the board data
                        this.load(null, false, true, 'yt_download_success');
                    });
                })
                .catch(error => {
                    console.error('Error:', error);
                    Swal.fire({
                        title: 'Error',
                        text: error.response?.data?.message || 'An error occurred while processing the URL.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        theme: 'auto'
                    });
                });
        },
        showRecordAudioModal: async function () {
            console.log('recordAudio');

            //Close all modals
            document.querySelectorAll('.modal').forEach(modalEl => {
                const modalInstance = bootstrap.Modal.getInstance(modalEl);
                if (modalInstance) modalInstance.hide();
            });

            //Open record audio modal
            const recordAudioModal = new bootstrap.Modal(document.getElementById('recordAudioModal'));
            recordAudioModal.show();
        },
        onRecordedBlob: function ({ blob }) {
            const file = new File([blob], 'recording.mp3', { type: 'audio/mpeg' });
            this.store_sound({ file, autoLabel: true });
        },
        showEditorModal: function (sound) {
            //Open audio editor modal
            console.log('showEditorModal sound: ', sound);
            this.selectedSound = sound;
            const editorModal = new bootstrap.Modal(document.getElementById('editorModal'));
            editorModal.show();
        },
        closeEditorModal: function () {
            //Close audio editor modal
            console.log('closeEditorModal');
            const editorModal = bootstrap.Modal.getInstance(document.getElementById('editorModal'));
            if (editorModal) editorModal.hide();
            this.editSoundsEnabled = false;
        },
        queueTranscription: function () {
            console.log('queueTranscription');
            Swal.fire({
                title: 'Auto Label',
                html: 'Auto label will automatically transcribe the sounds on your soundboard using speech to text.<br><br>It will erase the existing labels, and cannot be undone.<br><br>This will use A.I. to type out the words in your sounds, and automatically label them. If a sound was already auto labelled, it will not be labelled again.<br><br>Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Auto Label',
                cancelButtonText: 'Cancel',
                theme: 'auto'
            }).then((result) => {
                if (!result.isConfirmed) {
                    return false;
                }

                axios.post('/api/v1/boards/' + this.board.id + '/queue_transcription')
                    .then((response) => {
                        console.log(response.data);
                        Swal.fire({
                            title: 'Auto Label',
                            html: '<p>Your soundboard will be automatically transcribed using Speech to Text technology.</p><p>This should only take a few minutes.</p>',
                            icon: 'info',
                            confirmButtonText: 'OK',
                            theme: 'auto'
                        });
                    })
                    .catch((error) => {
                        console.error('An error occurred', error);
                        Swal.fire({
                            title: 'Error',
                            text: 'An error occurred requesting transcription. Please try again.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            theme: 'auto'
                        });
                    });
            });
        },
        cloneAsTts: function () {
            console.log('cloneAsTts');

            // //Navigate to blog article about voice cloning being unavailable
            // window.location.href = '/blog/voice-cloning-no-longer-available';
            // return false;

            //Ignore live updates of board being deleted
            this.ignoreBoardDeleted = true;

            //Check if this board has at least one sound using API
            axios.get('/api/v1/boards/' + this.board.id).then(response => {
                console.log(response);
                if (response.data.sounds_count === 0) {
                    Swal.fire({
                        title: 'Problem',
                        html: 'At least one sound is required for TTS voice generation. Upload a sound (around 10 seconds long with 3 words minimum) and try again.',
                        icon: 'error',
                        buttons: {
                            OK: true
                        },
                        theme: 'auto'
                    });

                    return false;
                }

                //Ask for confirmation
                Swal.fire({
                    title: 'Voice Clone',
                    html: `
                        <div style="max-height:55vh;overflow-y:auto;overflow-x:hidden;padding-right:12px;text-align:left;">
                            <a class="btn btn-small btn-danger text-white w-100" href="/pages/clone-a-voice">Instructions</a> <a class="btn btn-small btn-danger text-white w-100 mt-2 mb-2" href="https://www.youtube.com/watch?v=xeDTr6WMpcU" target="_blank">Tutorial video</a>
                            <strong><i class="fas fa-fw fa-stopwatch"></i> 10 seconds and 3 words MINIMUM is the sweet spot.</strong>
                            More audio doesn't improve quality - it can actually make cloning worse. <a href="/pages/editor" target="_blank">Trim</a> to your best clips.
                            <br><br>
                            <strong><i class="fas fa-fw fa-volume-mute"></i> Speech only.</strong>
                            We now automatically remove background music and sounds, no need to separate vocals from music. Just use clips with clear speech.
                            <br><br>
                            <strong><i class="fas fa-fw fa-lightbulb"></i> Got lots of samples?</strong>
                            Consider making separate boards for different expressions - e.g. <em>Normal</em>, <em>Angry</em>, <em>Surprised</em> - and clone each as its own voice.
                            <br><br>
                            <span class="text-danger font-weight-bold">Warning:</span> Do not clone voices you don't own.
                        </div>
                    `,
                    // icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Clone as TTS Voice',
                    cancelButtonText: 'Cancel',
                    input: 'checkbox',
                    inputPlaceholder: 'I understand I am cloning this board as a new TTS voice board',
                    preConfirm: (checked) => {
                        if (!checked) {
                            Swal.showValidationMessage('You must confirm that you understand you are cloning this board as a new TTS voice board.');
                            return false;
                        }
                        return true;
                    },
                    theme: 'auto'
                }).then((result) => {
                    if (result.isConfirmed) {
                        //Show loading toast
                        const loadingToast = Swal.fire({
                            title: 'Creating TTS Voice Clone...',
                            text: 'Please wait while we prepare your voice for processing...',
                            icon: 'info',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                            showConfirmButton: false,
                            didOpen: () => {
                                Swal.showLoading()
                            },
                            theme: 'auto'
                        });

                        //Clone as TTS
                        axios.post('/api/v1/boards/' + this.board.id + '/clone_as_tts', {
                            delete_original: false
                        }).then(response => {
                            //Close loading toast
                            loadingToast.close();
                            console.log('clone_as_tts response', response);

                            if (!response.data || !response.data.data || !response.data.data.board || !response.data.data.board.link) {
                                console.error('clone_as_tts response problem', response);
                                Swal.fire({
                                    title: 'Problem',
                                    html: 'There was a problem creating your TTS board. Please try again.',
                                    icon: 'error',
                                    theme: 'auto'
                                });
                                return false;
                            }

                            const new_board = response.data.data.board;
                            console.log('New board', new_board);

                            //Display Swal alert with a countdown timer
                            let timerInterval = null;
                            Swal.fire({
                                title: 'Converting to Text-To-Speech',
                                html: 'Your soundboard is being converted as a Text-To-Speech board.<br><br>Please wait <code></code> for processing...<br /><br />You can view your soundboards at <a href="/home" target="_blank" class="btn btn-danger ml-1"><i class="fa fa-fw fa-home mr-2"></i>My Soundboards</a>',
                                timer: 30000,
                                timerProgressBar: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                                didOpen: () => {
                                    Swal.showLoading()
                                    timerInterval = setInterval(() => {
                                        const content = Swal.getHtmlContainer()
                                        if (content) {
                                            const code = content.querySelector('code')
                                            if (code) {
                                                const timeLeft = Math.round(Swal.getTimerLeft() / 1000)
                                                code.textContent = `${timeLeft} ${pluralize('second', timeLeft)}`
                                            }
                                        }
                                    }, 100)
                                },
                                willClose: () => {
                                    clearInterval(timerInterval)
                                },
                                theme: 'auto'
                            }).then((result) => {
                                // if (result.dismiss === Swal.DismissReason.timer) {
                                //     console.log('I was closed by the timer')
                                //Go to new board page
                                window.location.href = new_board.link;
                                // }
                            })
                        }).catch(error => {
                            console.error('error', error);
                            Swal.fire({
                                title: 'Problem',
                                html: error.response.data.message,
                                icon: 'error',
                                buttons: {
                                    OK: true
                                },
                                theme: 'auto'
                            });
                        });
                    }
                });

            }).catch(error => {
                console.error(error);

                Swal.fire({
                    title: 'Problem',
                    html: 'An error occurred checking if this board has sounds. Please try again.',
                    icon: 'error',
                    buttons: {
                        OK: true
                    },
                    theme: 'auto'
                });
            });
        },
        //Queue a phrase using the TTS voice for this board
        queueTTSPhrase: function () {
            console.log('queueTTSPhrase');
            console.log('Phrase: ' + this.ttsPhraseText);

            //Analytics
            if (typeof gtag !== 'undefined') {
                gtag('event', 'queueTTSPhrase', {
                    'event_category': 'queueTTSPhrase',
                    'event_label': 'queueTTSPhrase',
                });
            };

            if (!this.ttsPhraseText) {
                console.log('Empty phrase');
                return false;
            }

            this.ttsCallPending = true;
            axios.post('/api/v1/boards/' + board_id + '/tts_phrase', {
                phrase_text: this.ttsPhraseText,
                language: this.ttsLanguage,
            }).then(response => {
                console.log(response);

                //Clear phrase
                this.ttsPhraseText = null;

                //Show modal informing of status
                this.$refs.ttsRequestModal.show();
            }).catch(error => {
                console.error(error);
                this.showErrorMessage(error.response.data.message);
            }).then(() => {
                //Clear pending indicator
                this.ttsCallPending = false;
            });
        },
        closeTtsRequestModal: function () {
            this.$refs.ttsRequestModal?.hide();
        },
        fetchTtsStats: function () {
            axios.get('/api/v1/tts/stats').then(response => {
                const stats = response.data?.data?.tts_engines_stats;
                if (stats && this.board.tts_engine_id && stats[this.board.tts_engine_id]) {
                    this.ttsProblem = stats[this.board.tts_engine_id].problem ?? false;
                }
            }).catch(error => {
                console.log('Failed to fetch TTS stats', error);
            });
        },
        //Enhance the current phrase using AI and populate the input with the improved text
        enhancePhraseWithAI: function () {
            console.log('enhancePhraseWithAI');

            if (!this.ttsPhraseText) {
                return false;
            }

            this.aiEnhancing = true;

            axios.post('/api/v1/boards/' + board_id + '/tts_enhance', {
                phrase_text: this.ttsPhraseText,
            }).then(response => {
                console.log('AI Enhanced phrase:', response.data.data.enhanced_phrase);
                this.aiEnhanceOriginalText = this.ttsPhraseText;
                this._aiEnhanceSkipWatch = true;
                this.ttsPhraseText = response.data.data.enhanced_phrase;
                this.aiEnhanced = true;
            }).catch(error => {
                console.error(error);
                this.showErrorMessage(error.response?.data?.message ?? 'AI Enhance failed. Please try again.');
            }).then(() => {
                this.aiEnhancing = false;
            });
        },
        undoAiEnhance: function () {
            if (!this.aiEnhanceOriginalText) return;
            this._aiEnhanceSkipWatch = true;
            this.ttsPhraseText = this.aiEnhanceOriginalText;
            this.aiEnhanceOriginalText = null;
            this.aiEnhanced = false;
        },
        insertExpressionTag: function (tag) {
            const el = this.$refs.phraseTextarea;
            const text = this.ttsPhraseText ?? '';
            const start = el ? el.selectionStart : text.length;
            const end = el ? el.selectionEnd : text.length;
            const needsSpace = start > 0 && text[start - 1] !== ' ';
            const insert = (needsSpace ? ' ' : '') + tag + ' ';
            this.ttsPhraseText = text.slice(0, start) + insert + text.slice(end);
            this.$nextTick(() => {
                if (el) {
                    const pos = start + insert.length;
                    el.focus();
                    el.setSelectionRange(pos, pos);
                }
            });
        },
        openTtsLangDropdown: function () {
            this.ttsLangDropdownOpen = true;
            this.$nextTick(() => {
                document.addEventListener('click', this.closeTtsLangDropdown, { once: true });
            });
        },
        closeTtsLangDropdown: function () {
            this.ttsLangDropdownOpen = false;
        },
        //Automatically scroll to have results and search bar in view
        autoscrollToSearchAndSelect: function () {
            var element = document.getElementById('ads_top_anchor');
            if (!element) return;
            
            var headerOffset = 60;
            // Use requestAnimationFrame to schedule layout read at optimal time
            requestAnimationFrame(() => {
                var elementPosition = element.getBoundingClientRect().top;
                var offsetPosition = elementPosition - headerOffset;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
                //Select the text for easy overtyping
                element.select();
            });
        },
        selectText: function (element) {
            element.select(element)
        },
        handleKeyboardPress: function (event) {
            //If a keyboard key is pressed, play a relevant sound
            //Sound order is from keysOrderArray which is a natural list of keyboard keys
            console.log('keyboardPress', event.key, event.code, document.activeElement.tagName, document.activeElement.id)

            //Ignore keypresses on input elements
            if (document.activeElement.tagName.toLowerCase() === 'input' || document.activeElement.tagName.toLowerCase() === 'textarea') {
                console.log('Ignoring this keypress')
                return true;
            }

            //Ignore key presses if Alt or Ctrl was held down
            if (event.altKey || event.ctrlKey) {
                return true;
            }

            //If escape pressed, stop all sounds
            if (event.key === 'Escape') {
                this.stopAllSounds()
                return true;
            }

            //Find pressed key order position
            const keyOrder = this.keysOrderArray.indexOf(event.key)
            console.log('Key order position', keyOrder)

            //If there is no sound for this position e.g. not enough sounds
            console.log(this.board.sounds[keyOrder]);
            if (typeof this.board.sounds[keyOrder] === 'undefined') {
                return true;
            }

            //Play the sound
            const soundToPlay = this.board.sounds[keyOrder]
            this.$refs['soundPlayer_' + soundToPlay.id][0].play();

            return true;
        },
        getKeyboardKey: function (index) {
            return this.keysOrderArray[index]
        },
        stopAllSounds: function () {
            console.log('stopAllSounds')
            // this.board.sounds.forEach((sound) => {
            //     if (this.$refs['soundPlayer_' + sound.id]) {
            //         this.$refs['soundPlayer_' + sound.id][0].stop()
            //     }
            // })

            //Stop all audio on page playing using Javascript
            var sounds = document.getElementsByTagName('audio');
            for (var i = 0; i < sounds.length; i++) {
                console.log('stopAllSounds pausing sound ' + i + ' element name: ' + sounds[i].id, sounds[i], sounds[i].pause);
                sounds[i].pause();
            }
        },
        ttsRemove: function (sound) {
            console.log('ttsRemove', sound);

            //Ask for confirmation with SWAL
            Swal.fire({
                title: 'Remove TTS Phrase',
                html: 'Are you sure you want to remove this TTS phrase?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Remove',
                cancelButtonText: 'Cancel',
                theme: 'auto'
            }).then((result) => {
                if (result.isConfirmed) {
                    //Immediate UI feedback
                    this.dataLoadingInProgress = true;

                    //Remove sound
                    axios.delete('/api/v1/sounds/' + sound.id)
                        .then((response) => {
                            console.log(response);
                            //Reload data
                            this.load(false, false, true, 'ttsRemove');
                        })
                        .catch((error) => {
                            console.error(error);
                            this.showErrorMessage(error.response.data.message);
                            this.dataLoadingInProgress = false;
                        });
                }
            });
        },
        addToFavorites: function (sound) {
            //Add to favorites
            console.log('addToFavorites', sound);
            console.log(sound);

            //Check if already in favorites
            if (this.favorites.includes(sound.id)) {
                //Already in favorites, delete
                console.log('Already in favorites. Removing...');

                //Remove from favorites for instant user feedback
                _.remove(this.favorites, (favorite) => favorite === sound.id);

                axios.delete(`/api/v1/favorites/${sound.id}`)
                    .then((response) => {
                        console.log(response);

                        window.$toast.add({
                            severity: 'success',
                            summary: 'Removed from favorites',
                            html: '<a class="btn btn btn-danger mt-1" href="/favorites/me">My Favorites</a>',
                            life: 10000
                        });
                    })
                    .catch((error) => {
                        console.error(error);
                        console.log('Showing error toast...')
                        Swal.fire({
                            title: 'Problem',
                            text: 'There was a problem with your favorites. Please try again.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            theme: 'auto'
                        });

                        //Add back to favorites
                        this.favorites.push(sound.id);
                    });

                return true;
            }

            //Otherwise, continue adding
            console.log('Adding to favorites...');

            //Add to end of favorites for instant user feedback
            this.favorites.push(sound.id);

            axios.put(`/api/v1/favorites/${sound.id}`)
                .then((response) => {
                    console.log(response);
                    console.log('Showing toast...')

                    window.$toast.add({
                        severity: 'success',
                        summary: 'Added to favorites',
                        html: '<a class="btn btn btn-danger mt-1" href="/favorites/me">My Favorites</a>',
                        life: 10000
                    });
                })
                .catch((error) => {
                    console.error(error);
                    console.log('Showing error toast...')

                    Swal.fire({
                        title: 'Problem',
                        text: 'There was a problem with your favorites. Please try again.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        theme: 'auto'
                    });

                    //Remove from favorites
                    _.remove(this.favorites, (favorite) => favorite === sound.id);
                });
        },
        loadFavorites: function () {
            console.log('loadFavorites');
            //Load with axios
            axios.get('/api/v1/favorites/me')
                .then(response => {
                    console.log(response);
                    this.favorites = response.data.data;
                })
                .catch(error => {
                    console.error(error);
                    // this.showErrorMessage(error);
                    window.$toast.add({
                        severity: 'error',
                        summary: 'Error loading favorites',
                        detail: 'There was a problem loading your favorites. Please try again.',
                        life: 10000
                    });
                });
        },
        isFavorite: function (sound) {
            //Check if sound is in favorites
            return this.favorites.includes(sound.id);
        },
        report: function (sound) {
            //Report sound
            console.log('report', sound);
            console.log(sound);

            Swal.fire({
                title: 'Report Sound',
                html: 'Are you sure you want to report this sound?<br><br>You should only report sounds with offensive content, personal details, or if this was a Text-to-Speech phrase you created and would like to be removed.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Report',
                cancelButtonText: 'Cancel',
                theme: 'auto'
            }).then((result) => {
                if (!result.isConfirmed) {
                    return false;
                }

                axios.put(`/api/v1/sounds/${sound.id}/reports`)
                    .then(function (response) {
                        console.log(response);
                        console.log('Showing alert...')

                        Swal.fire({
                            title: 'Sound Reported',
                            text: 'Sound reported. Our moderators will review it shortly. If you reported a TTS phrase you created, it will be removed momentarily.',
                            icon: 'success',
                            buttons: {
                                OK: true
                            },
                            timer: 5000,
                            timerProgressBar: true,
                            theme: 'auto'
                        })
                    })
                    .catch(function (error) {
                        console.error(error);
                        console.log('Showing error alert...')
                        Swal.fire({
                            title: 'Error',
                            text: 'There was a problem reporting this sound. Please try again.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            timer: 5000,
                            timerProgressBar: true,
                            theme: 'auto'
                        });
                    });
            });
        },
        showMoreSounds: function (number_of_sounds) {
            console.log('showMoreSounds', number_of_sounds);
            // if (window.confirm('Are you sure you want to show more sounds? This may take a while to load.') === true) {
            this.soundsDisplayLimit = Math.min(this.soundsDisplayLimit + number_of_sounds, this.board.sounds_count);
            this.load(false, false, true, 'show_more_sounds')
            // }
        },
        showAllSounds: function () {
            console.log('showAllSounds');
            if (window.confirm('Are you sure you want to show all sounds? This may take a while to load.') === true) {
                this.soundsDisplayLimit = 75000; //75,000 hard limit
                this.load(false, false, true, 'display_all_sounds')
            }
        },
        setNSFW: function (nsfw) {
            console.log('setNSFW', nsfw);
            axios.put(`/api/v1/boards/${this.board.id}/nsfw`, { nsfw: Boolean(nsfw) })
                .then(function (response) {
                    console.log(response);
                    window.location.reload(true);
                })
                .catch(function (error) {
                    console.error(error);
                    this.showErrorMessage(error);
                });
        },
        makeF5Tts: function (tts) {
            console.log('makeF5Tts');

            //Ask for confirmation
            if (!confirm("Are you sure you want to make this board an F5 TTS board?")) {
                return false;
            }

            axios.put(`/api/v1/boards/${this.board.id}/f5_tts`, { tts: Boolean(tts) })
        },
        duplicate: function () {
            console.log('duplicate');

            //Ask for confirmation
            if (!confirm("Are you sure you want to duplicate this board?")) {
                return false;
            }

            axios.post(`/api/v1/boards/${this.board.id}/duplicate`).then((response) => {
                console.log(response);
                window.location.href = response.data.link;
            }).catch((error) => {
                console.error(error);
                this.showErrorMessage('Error duplicating board. Perhaps it has already been duplicated.');
            });
        },
        consolidate: function (delete_after) {
            console.log('consolidate');

            //Ask for confirmation
            if (!confirm("Are you sure you want to consolidate this board?")) {
                return false;
            }

            alert('Consolidating board...');

            axios.post(`/api/v1/boards/${this.board.id}/consolidate`, { delete_after: Boolean(delete_after) }).then((response) => {
                console.log(response);
                alert('Board consolidation in progress.');
            }).catch((error) => {
                console.error(error);
                this.showErrorMessage('Error consolidating board.');
            });
        },
        sortDo() {
            console.log('sortDo');
            //Load data which will be sorted server-side
            this.load(false, false, true, 'sort');

            //Hide tooltip
            const sortElement = document.getElementById('sort');
            if (sortElement && typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
                const tooltip = bootstrap.Tooltip.getInstance(sortElement);
                if (tooltip) {
                    tooltip.hide();
                }
            }

            //Analytics
            if (typeof gtag !== 'undefined') {
                gtag('event', 'sort', {
                    'event_category': 'sort',
                    'event_label': 'sort',
                });
            };
        },
        filterDoDebounced: _.debounce(function () {
            console.log('filterDoDebounced');
            this.filterDo();
        }, 750),
        filterDo() {
            console.log('filterDo');
            //Load data which will be filtered server-side
            this.load(false, false, true, 'filter');

            //Analytics
            if (typeof gtag !== 'undefined') {
                gtag('event', 'filter', {
                    'event_category': 'filter',
                    'event_label': 'filter',
                });
            };
        },
        checkTtsPhraseBlockedByProfanity: function () {
            console.log('check profanity for text: ', this.ttsPhraseText);
            const profanity_result = profanity.exists(String(this.ttsPhraseText));
            console.log('Profanity result: ', profanity_result);
            this.isProfanity = profanity_result;
        },
        checkTtsPhraseBlockedByProfanityDebounced: _.debounce(
            function () {
                return this.checkTtsPhraseBlockedByProfanity();
            },
            3000),
        shouldPreload(sound) {
            console.log('shouldPreload');

            //No preload for low bandwidth clients
            if (this.isLowBandwidth) {
                return false;
            }

            //Find position of sound on board
            const soundPositionOnBoard = this.board.sounds.findIndex(s => s.id === sound.id);
            console.log('Sound position on board:', soundPositionOnBoard, 'sound id:', sound.id);

            //Only preload the first x sounds
            if (soundPositionOnBoard >= this.preloadSoundsLimit) {
                console.log('Preloading sound: No', 'sound position:', soundPositionOnBoard, 'sound id:', sound.id, 'preloadSoundsLimit:', this.preloadSoundsLimit);
                return false;
            }

            //Default to full preload
            console.log('Preloading sound: Yes', 'sound position:', soundPositionOnBoard, 'sound id:', sound.id, 'preloadSoundsLimit:', this.preloadSoundsLimit);
            return true;
        },
        handlePageChange(event) {
            console.log("Sounds component: Page change requested to", event.page + 1);

            this.page = event.page + 1;
            this.load();
        },
        handleRowsChange(newPerPage) {
            console.log("Sounds component: Per page change requested to", newPerPage);

            //Only update perPage and reload if the value actually changed
            if (this.perPage === newPerPage) {
                console.log("Sounds component: Per page value unchanged, not reloading.");
                return;
            }

            this.perPage = newPerPage;
            this.load();
        },
    },
    created: function () {
        const errorMessage = document.getElementById("errorMessage");
        if (errorMessage) {
            errorMessage.style.display = "none";
        }
        if (typeof window.board_data_inline !== 'undefined') {
            this.load(window.board_data_inline, true, true, 'created_inline_data')
        } else {
            this.load(null, true, true, 'created_no_inline_data');
        }
    },
    computed: {
        searchCount: function () {
            return (this.searchData.boards.length + this.searchData.sounds.length);
        },
        searchCounts: function () {
            return ({
                'boards': this.searchData.boards.length,
                'sounds': this.searchData.sounds.length
            })
        },
        sounds_alphaSections: function () { //Sounds, sorted in alpha order, and separated into character sections
            //Note: Computed properties and v-for won't work if array indexes are not integers
            console.log('Vue computed sounds_alphaSections');
            return alphaSectionsMake(this.board.sounds, 'sound_transcript');
        },
        soundsCount: function () {
            return (this.board.sounds.length);
        },
        showMoreAvailable: function () {
            //If there are more sounds to be retrieved
            if (this.board.sounds_count > this.board.sounds.length) {
                return true;
            }

            //If no limit set
            if (this.soundsDisplayLimit === 0) {
                return false;
            }

            //If there are more sounds to be displayed
            if (this.board.sounds_count > this.soundsDisplayLimit) {
                return true;
            }

            return false;
        },
        shouldShowWaveforms: function () {
            //Should waveforms be shown on sound player buttons
            //No waveforms for mobile
            if (this.isMobile) {
                return false;
            }
            //No waveforms for low bandwidth clients
            if (this.isLowBandwidth) {
                return false;
            }
            //Don't show for TTS boards
            if ("board_is_tts" in this.board && this.board.board_is_tts === true) {
                return false;
            }
            //If recommend no preload, do not load waveforms
            if (this.board.recommend_preload === 'none') {
                return false;
            }
            //Over 200 sounds, no waveforms
            if (typeof this.board.sounds !== 'undefined' && this.board.sounds.length > 200) {
                return false;
            }
            //Default
            return true;
        },
        relTags: function () {
            var rel = null;
            if (this.board.board_is_tts) {
                rel = 'nofollow';
            }
            return rel;
        },
        //Get the list of sounds limited to display length
        soundsWithLimit: function () {
            return this.board.sounds
                .filter(sound => sound.uploaded_at !== null)
                .slice(0, this.soundsDisplayLimit)
        },
        //Check if the list of sounds is long
        soundsIsLong: function () {
            return this.board.sounds.length > 100;
        },
        ttsMaxLength: function () {
            if (!this.board || !this.board.tts_engine) {
                return 1000;
            }

            return this.board.tts_engine.max_chars ? this.board.tts_engine.max_chars : 1000;
        },
        ttsFormPlaceholder: function () {
            if (!this.board || !this.board.tts_engine) {
                return '💬 Enter your text...';
            }

            return this.board.tts_engine.is_singing ? '🪕 Suggest some lyrics and let us craft a song for you...' : '💬 Enter your text...';
        },
        soundUploadProgressStyleWidth: function () {
            return Math.round(this.soundUploadProgress) + '%';
        },
        soundUploadProgressRounded: function () {
            return Math.round(this.soundUploadProgress);
        },
        //TTS form computed properties
        ttsButtonDisabled: function () {
            if (!this.ttsPhraseText) return true;
            if (this.board.tts_engine?.max_chars && this.ttsPhraseText.length > this.board.tts_engine.max_chars) return true;
            if (this.ttsCallPending) return true;
            return false;
        },
        ttsButtonAnimationClass: function () {
            if (this.ttsCallPending) return 'animate__animated animate__bounce';
            if (this.ttsPhraseText && (!this.board.tts_engine?.max_chars || this.ttsPhraseText.length <= this.board.tts_engine.max_chars)) {
                return 'animate__animated animate__heartBeat animate__infinite animate__slower';
            }
            return '';
        },
        ttsCharsRemaining: function () {
            if (!this.board.tts_engine?.max_chars) return null;
            return this.ttsPhraseText ? this.board.tts_engine.max_chars - this.ttsPhraseText.length : this.board.tts_engine.max_chars;
        },
        ttsLanguageFlagCode: function () {
            const option = this.ttsLanguageOptions.find(o => o.value === this.ttsLanguage);
            return option?.flag ?? null;
        },
        ttsLanguageLabel: function () {
            const option = this.ttsLanguageOptions.find(o => o.value === this.ttsLanguage);
            return option?.label ?? 'Auto';
        },
    },
    // //Debugging
    // renderTracked(event) {
    //     console.log('renderTracked', 'key:', event.key, event, event.target);
    //     // debugger
    // },
    // renderTriggered(event) {
    //     console.log('renderTriggered', event);
    //     // debugger
    // },
    watch: {
        ttsLanguage(newVal) {
            try {
                if (newVal) {
                    localStorage.setItem('tts_language', newVal);
                } else {
                    localStorage.removeItem('tts_language');
                }
            } catch (e) {
                // localStorage not available
            }
        },
        ttsPhraseText(newVal, oldVal) {
            this.checkTtsPhraseBlockedByProfanityDebounced();
            // If the change came from the AI enhance method, skip resetting the enhanced state
            if (this._aiEnhanceSkipWatch) {
                this._aiEnhanceSkipWatch = false;
                return;
            }
            this.aiEnhanced = false;
            this.aiEnhanceOriginalText = null;
        },
        // checkTtsPhraseBlockedByProfanity: function () {
        //     console.log('check profanity for text: ', this.ttsPhraseText);
        //     const profanity_result = profanity.exists(String(this.ttsPhraseText));
        //     console.log('Profanity result: ', profanity_result);
        //     this.isProfanity = profanity_result;
        // },
        editSoundsEnabled: function (newVal, oldVal) {
            console.log('editSoundsEnabled changed', newVal, oldVal);
            //If it changes to true, controlsVisible should become true
            if (newVal === true) {
                this.controlsVisible = true;
            }
        },
    },
    mounted: function () {
        console.log('Mounted');
        console.log('Crossroads begin');

        //Restore language selection from localStorage
        try {
            const validLangs = ['ar','da','de','el','en','es','fi','fr','he','hi','it','ja','ko','ms','nl','no','pl','pt','ru','sv','sw','tr','zh'];
            const stored = localStorage.getItem('tts_language');
            if (stored && validLangs.includes(stored)) {
                this.ttsLanguage = stored;
            }
        } catch (e) {
            // localStorage not available
        }

        //Add route for handling search
        crossroads.addRoute('/search/{searchText}', (searchText) => {
            searchText = decodeURIComponent(searchText);
            console.log('search Route', searchText);
            this.searchText = searchText;
            this.search();
        });

        //Log all routes
        crossroads.routed.add(console.log, console);

        //Parse URL on load
        crossroads.parse(document.location.pathname);

        //Listen for live updates
        console.log('Subscribing to live updates');
        window.Echo.channel(`App.Models.Board.${board_id}`)
            .listen('.BoardUpdated', (e) => {
                console.log('Updated event received', e);

                //Dispatch event
                window.dispatchEvent(new Event('BoardUpdated'));

                //If title changed, reload the page
                if (this.board.board_title && e.model.board_title && this.board.board_title !== e.model.board_title) {
                    console.log('Title has changed, reloading');
                    window.location.reload(true);
                    return true
                }

                console.log('Websockets indicates update to board sounds');

                //If user has edited sounds in this view, do not reload, and show stale notice instead
                if (this.soundsEdited) {
                    this.boardStale = true; //To show a notice indicating to reload the page to update
                    return true;
                }

                // //Set sort to latest before reloading
                // this.sort = '-id';

                // Reload, if this is not a TTS board
                if (this.board.board_is_tts) {
                    console.log('This is a TTS board, not reloading to avoid interrupting user');
                    return true;
                }

                this.load(false, false, true, 'websockets2');
                return true;
            })
            .listen('.BoardDeleted', (e) => {
                if (!this.ignoreBoardDeleted) {
                    //Listen if board was deleted and reload the page to show 404
                    console.log('Board was deleted. Reloading');
                    window.location.reload(true);
                    return true;
                }
            });

        //Listen for everyone meep. A way to play a sound on all viewers' browsers at the same time
        //use App\Events\EveryoneMeep
        //EveryoneMeep::dispatch('/audio/coin.mp3');
        console.log('Subscribing to everyone meep');
        window.Echo.channel('everyone-meep')
            .listen('EveryoneMeep', (e) => {
                console.log('Everyone meep event received');
                console.log(e);
                const audio = new Audio(e.audio_url);
                audio.volume = 0.4;
                audio.play().then(() => { console.log('Sound played') }).catch((error) => { console.log('Sound play error', error) })
            });

        //Listen for everyone refresh. A way to refresh all viewers' browsers at the same time for example on critical bug fix
        //use App\Events\EveryoneRefresh
        //EveryoneRefresh::dispatch();
        console.log('Subscribing to everyone refresh');
        window.Echo.channel('everyone-refresh')
            .listen('EveryoneRefresh', (e) => {
                console.log('EveryoneRefresh event received');
                console.log(e);
                window.location.reload()
            });

        //Keyboard listener
        document.addEventListener('keydown', this.handleKeyboardPress);

        //Listen for volume change events
        window.addEventListener('volumeChange', (event) => {
            console.log('There was a volume change event (board.js)')
            console.log(event)
            console.log(event.volume)
            this.volume = event.volume
        })

        //Regularly check if data has expired, and reload if it has (unless it is TTS)
        if (this.board.board_is_tts) {
            this.fetchTtsStats();

            const reloadDataAfter = 15 * 60 * 1000;
            setInterval(() => {
                console.log('Checking if data has expired')
                if (this.board_data_lastRetrieved && this.board_data_lastRetrieved < Date.now() - reloadDataAfter) {
                    console.log('Data has expired... refreshing data', this.board_data_lastRetrieved, Date.now(), this.board_data_lastRetrieved < Date.now() - reloadDataAfter)
                    this.load(false, false, false, 'interval')
                } else {
                    console.log('Data has not expired')
                }
            }, 30 * 1000);
        }

        //Load listview preference from cookies
        console.log('Loading listview preference from cookies');
        console.log(Cookies.get('listview'));
        switch (Cookies.get('listview')) {
            case 'list':
                this.listViewToggle('list');
                break;

            case 'board':
                this.listViewToggle('board');
                break;

            default:
                // //If no preference and a TTS board, default to list view, otherwise default to board view
                // switch (this.board.board_is_tts) {
                //     case true:
                //         this.listViewToggle('list', false);
                //         break;

                //     default:
                //         this.listViewToggle('board', false);
                //         break;
                // }
                //If no preference, default to list view
                this.listViewToggle('list', false);
        }

        //Load controls visible preference from localStorage
        console.log('Loading controlsVisible preference from localStorage');
        const controlsVisiblePref = localStorage.getItem('controlsVisible');
        switch (controlsVisiblePref) {
            case 'false':
                console.log('Controls visible disabled by localStorage');
                this.controlsVisible = false;
                break;

            case 'true':
                console.log('Controls visible enabled by localStorage');
                this.controlsVisible = true;
                break;

            default:
                console.log('No controlsVisible preference in localStorage');
        }
        
        //Check if this is a mobile browser
        if (window.matchMedia("(max-width: 767px)").matches) {
            //The viewport is less than 768 pixels wide
            console.log("This is a mobile device")
            this.isMobile = true
        }

        //Check for low bandwidth device. Not available on all browsers
        if (typeof navigator.connection !== 'undefined' && typeof navigator.connection.downlink !== 'undefined') {
            const downlinkSpeed = navigator.connection.downlink;
            console.log('downlinkSpeed: ', downlinkSpeed);
            if (downlinkSpeed < 7.5) {
                this.isLowBandwidth = true;
            }
            if (downlinkSpeed >= 7.5) {
                this.isLowBandwidth = false;
            }
            console.log('isLowBandwidth: ' + this.isLowBandwidth)
        }

        //Limit number of sounds to preload
        if (this.isMobile) {
            this.preloadSoundsLimit = 10;
        } else {
            this.preloadSoundsLimit = 30; //Default
        }

        //Check for back or forward button press, and reload data if necessary
        console.log('Setting up popstate listener');
        window.addEventListener('popstate', (event) => {
            console.log('Popstate, user entered page via back or forward button');
            this.load(false, false, true, 'popstate');
        });

        //Load favorites
        this.loadFavorites();
    }
})
    .component('sound-uploader', SoundUploader)
    .component('image-uploader', ImageUploader)
    .component('sound-player', SoundPlayer)
    .component('audio-editor', AudioEditor)
    .component('transcript-suggestion', TranscriptSuggestion)
    .component('tag-voter', TagVoter)
    .component('search', Search)
    .component('crosspromotion', Crosspromotion)
    .component('audio-recorder', AudioRecorder)
    .component('web-sockets-indicator', WebSocketsIndicator)
    .component('sound-downloader', SoundDownloader)
    .component('notification-preference', NotificationPreference)
    .component('favorite-board', FavoriteBoard)
    .component('tts-expression-tags', TtsExpressionTags)
    .component('paginator', Paginator)
    .component('my-tts-phrases', MyTTSPhrases)
    .component('tts-request-modal', TtsRequestModal)
    .use(LazyComponent)
    .use(PrimeVue, {
        theme: {
            preset: PrimeVuePreset,
            options: {
                prefix: 'p',
                darkModeSelector: 'system',
                cssLayer: false
            }
        },
    })
    .use(ToastService)
    .directive('tooltip', tooltipDirective)
    .mount('#vueApp');

document.addEventListener('DOMContentLoaded', () => {
    if (window.Echo && typeof window.user_id !== 'undefined' && typeof window.user_id === 'number') {
        window.Echo.private(`App.Models.User.${window.user_id}`)
            .notification((notification) => {
                console.log(notification.type);
                if (notification.type === 'App\\Notifications\\TranscriptionFinished') {
                    console.log('Transcription finished');
                    Swal.fire({
                        title: 'Transcription Complete',
                        text: 'Your requested Audio to Text transcription has finished, and is live on your soundboard.',
                        icon: 'success',
                        confirmButtonText: 'OK',
                        theme: 'auto'
                    });
                }
            });
    }
});
